module.exports = __webpack_public_path__ + "static/media/buffer.6d059dbd.svg";